import { render, staticRenderFns } from "./ReviewerVerification.vue?vue&type=template&id=224dca16&scoped=true&"
import script from "./ReviewerVerification.vue?vue&type=script&lang=js&"
export * from "./ReviewerVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224dca16",
  null
  
)

export default component.exports